const style = {
  lineHeight: "16px", // why px here
  margin: "16px 0 0 18px",
  fontSize: 17,
  fontWeight: 600
};

export function HeaderTitle(props) {
  return (<>
    <span style={ style }>{ props.text }</span>
  </>);
}
